import SiteTemplate from '@/templates/site-interno/SiteTemplate'
import Login from '@/pages/auth/Login'
import LoginAdmin from '@/pages/auth/LoginAdmin'
import Cadastro from '@/pages/auth/Cadastro'
import RecuperarSenha from '@/pages/auth/RecuperarSenha'
import AlterarSenha from '@/pages/auth/AlterarSenha'
import GerarSenha from '@/pages/auth/GerarSenha'
import PrimeiroAcesso from '@/pages/auth/PrimeiroAcesso'
import RedirectGov from '@/pages/auth/RedirectGov'
import AvisoAppLogin from '@/pages/auth/AvisoAppLogin'
// import HomeExterna from '@/pages/site/externa/Home'
import CaptchaExterno from '@/templates/site-externo/CaptchaExterno'
import CaptchaErro from '@/templates/site-externo/CaptchaErro'
import HomeInterna from '@/pages/site/interna/Home'
import Usuario from '@/pages/site/interna/administrador/usuarios/Usuarios'
import UsuariosVoluntarios from '@/pages/site/interna/administrador/usuarios/UsuariosVoluntarios'
import ValidarUsuariosGestor from '@/pages/site/interna/administrador/usuarios/ValidarUsuariosGestor'
import ValidarUsuariosTutor from '@/pages/site/interna/administrador/usuarios/ValidarUsuariosTutor'
import PrincipalVoluntario from '@/pages/site/interna/administrador/usuarios/voluntario/PrincipalVoluntario'
import MinhasBeneficiarias from '@/pages/site/interna/administrador/usuarios/voluntario/MinhasBeneficiarias'
import VisualizarBeneficiaria from '@/pages/site/interna/administrador/usuarios/voluntario/VisualizarBeneficiaria'
import FormularioAtendimento from '@/pages/site/interna/administrador/usuarios/voluntario/FormularioAtendimento'
import PrincipalBeneficiaria from '@/pages/site/interna/administrador/usuarios/PrincipalBeneficiaria'
import InformarDisponibilidade from '@/pages/site/interna/administrador/usuarios/voluntario/InformarDisponibilidade'
import Captchas from '@/pages/site/interna/administrador/captchas/Captchas'
import Noticias from '@/pages/site/interna/administrador/noticias/Noticias'
import NoticiaForm from '@/pages/site/interna/administrador/noticias/NoticiaForm'
import NoticiaVisualizar from '@/pages/site/interna/administrador/noticias/NoticiaVisualizar'
import Cursos from '@/pages/site/interna/administrador/cursos/Cursos'
import CursosLista from '@/pages/site/interna/administrador/cursos/CursosLista'
import CursoForm from '@/pages/site/interna/administrador/cursos/CursoForm'
import Informacoes from '@/pages/site/interna/administrador/informacoes/Informacoes'
import Informacao from '@/pages/site/interna/administrador/informacoes/Informacao'
import InformacaoVisualizar from '@/pages/site/interna/administrador/informacoes/InformacaoVisualizar'
import InformacaoForm from '@/pages/site/interna/administrador/informacoes/InformacaoForm'
import Programas from '@/pages/site/interna/administrador/programaGoverno/Programa'
import ProgramaForm from '@/pages/site/interna/administrador/programaGoverno/ProgramaForm'
import ProgramaLista from '@/pages/site/interna/administrador/programaGoverno/ProgramaLista'
import ProgramasDeMunicipio from '@/pages/site/interna/administrador/programaMunicipio/programaMunicipio'
import ProgramaMunicipioLista from '@/pages/site/interna/administrador/programaMunicipio/programaMunicipioLista'
import ProgramaMunicipioForm from '@/pages/site/interna/administrador/programaMunicipio/programaMunicipioForm'
import ProgramasDeMunicipioGestor from '@/pages/site/interna/administrador/programaMunicipio/programaMunicipioGestor'
import ProgramaMunicipioFormGestor from '@/pages/site/interna/administrador/programaMunicipio/programaMunicipioFormGestor'
import RelatorioEncontroBeneficiaria from '@/pages/site/interna/administrador/relatorioDeEncontro/relatorio'
import RelatorioEncontroBeneficiariaForm from '@/pages/site/interna/administrador/relatorioDeEncontro/relatorioForm'
import RelatorioEncontroBeneficiariaVisual from '@/pages/site/interna/administrador/relatorioDeEncontro/relatorioVisual'
import Municipios from '@/pages/site/interna/administrador/municipios/Municipios'
import MunicipioForm from '@/pages/site/interna/administrador/municipios/MunicipioForm'
import MunicipioFormGestor from '@/pages/site/interna/administrador/municipios/MunicipioFormGestor'
import Conteudos from '@/pages/site/interna/administrador/conteudos/Conteudos'
import ConteudoForm from '@/pages/site/interna/administrador/conteudos/ConteudoForm'
import ConteudoVisualizar from '@/pages/site/interna/administrador/conteudos/ConteudoVisualizar'
import CadastrarCaptcha from '@/pages/site/interna/administrador/captchas/CadastrarCaptcha'
import EditarCaptcha from '@/pages/site/interna/administrador/captchas/EditarCaptcha'
import UsuarioVisualizar from '@/pages/site/interna/administrador/usuarios/UsuarioVisualizar'
import UsuarioEditar from '@/pages/site/interna/administrador/usuarios/UsuarioEditar'
import UsuarioCadastrar from '@/pages/site/interna/administrador/usuarios/UsuarioCadastrar'
import RelatorioUsuariosSituacao from '@/pages/site/interna/administrador/relatorios/UsuarioSituacao'
import RelatorioUsuariosTipo from '@/pages/site/interna/administrador/relatorios/UsuarioTipo'
import RelatorioUsuariosVinculo from '@/pages/site/interna/administrador/relatorios/UsuarioVinculo'
import RelatorioUsuariosIdade from '@/pages/site/interna/administrador/relatorios/UsuarioIdade'
import RelatorioUsuariosTotal from '@/pages/site/interna/administrador/relatorios/UsuarioTotal'
import RelatorioDashboard from '@/pages/site/interna/administrador/relatorios/Dashboard'
import MeuPerfil from '@/pages/site/interna/perfil/MeuPerfil'
import Desistir from '@/pages/site/interna/perfil/Desistir'
import LocalCadastrar from '@/pages/site/interna/administrador/locais/LocalCadastrar'
import LocalEditar from '@/pages/site/interna/administrador/locais/LocalEditar'
import Locais from '@/pages/site/interna/administrador/locais/Locais'
import Permissoes from '@/pages/site/interna/administrador/permissoes/Permissoes'
import PermissaoCadastrar from '@/pages/site/interna/administrador/permissoes/PermissaoCadastrar'
import PermissaoEditar from '@/pages/site/interna/administrador/permissoes/PermissaoEditar'
import CadastroExterno from '@/pages/auth/CadastroExterno'
import CadastroBeneficiaria from '@/pages/auth/cadastro/Beneficiaria'
import CadastroGestor from '@/pages/auth/cadastro/Gestor'
import CadastroTutorInstrutor from '@/pages/auth/cadastro/TutorInstrutor'
import CadastroVoluntario from '@/pages/auth/cadastro/Voluntario'
import CadastroVoluntarioInterno from '@/pages/site/interna/administrador/usuarios/cadastro/Voluntario'
import CadastroBeneficiariaInterno from '@/pages/site/interna/administrador/usuarios/cadastro/Beneficiaria'
import CadastroTutorInstrutorInterno from '@/pages/site/interna/administrador/usuarios/cadastro/TutorInstrutor'
import CadastroGestorInterno from '@/pages/site/interna/administrador/usuarios/cadastro/Gestor'
import VolunteerCalendar from '@/pages/site/interna/administrador/usuarios/voluntario/Calendario'
import Configuracao from '@/pages/site/interna/administrador/configuracoes/Configuracao'

import AvaliarEncontroForm from '@/pages/site/interna/administrador/usuarios/beneficiaria/AvaliarEncontroForm'
import AvaliarEncontro from '@/pages/site/interna/administrador/usuarios/beneficiaria/AvaliarEncontro'

import Feedback from '@/pages/site/interna/administrador/feedback/feedback'
import FeedbackForm from '@/pages/site/interna/administrador/feedback/feedbackForm'
import FeedbackVisual from '@/pages/site/interna/administrador/feedback/feedbackVisual'
import FeedbackResposta from '@/pages/site/interna/administrador/feedback/feedbackResposta'

import Depoimentos from '@/pages/site/interna/administrador/depoimentos/depoimento'
import ListDepoimentos from '@/pages/site/interna/administrador/depoimentos/ListDepoimentos'

import Faq from '@/pages/site/interna/administrador/faq/Faq'
import ListFaq from '@/pages/site/interna/administrador/faq/ListFaq'
import FaqForm from '@/pages/site/interna/administrador/faq/FaqForm'
import FaqVisual from '@/pages/site/interna/administrador/faq/FaqVisual'

import RelatorioMensal from '@/pages/site/interna/administrador/relatorioMensal/Relatorio'
import RelatorioMensalForm from '@/pages/site/interna/administrador/relatorioMensal/RelatorioForm'
import RelatorioVisual from '@/pages/site/interna/administrador/relatorioMensal/RelatorioVisual'

import ArquivosMenu from '@/pages/site/interna/administrador/arquivosMenu/ArquivosMenu'
import AtualizaPerfil from '@/pages/site/interna/administrador/usuarios/cadastro/AtualizaCadastro'

import Texto from '@/pages/site/interna/administrador/textoApresentacao/Textos'
import TextoForm from '@/pages/site/interna/administrador/textoApresentacao/TextoForm'

import Instituicao from '@/pages/site/interna/administrador/instituicao/Instituicao'
import InstituicaoForm from '@/pages/site/interna/administrador/instituicao/InstituicaoForm'

import Rede from '@/pages/site/interna/administrador/rede/Rede'
import RedeForm from '@/pages/site/interna/administrador/rede/RedeForm'

import Mensages from '@/pages/site/interna/administrador/mensages/Mensages'
import MensageReencaminhar from '@/pages/site/interna/administrador/mensages/MensageReencaminhar'
import MensageVisualizar from '@/pages/site/interna/administrador/mensages/MensageVisualizar'
import MensageForm from '@/pages/site/interna/administrador/mensages/MensageForm'

import ClassificaRede from '@/pages/site/interna/administrador/classificaRede/ClassificaRede'

import Vue from 'vue'

const routes = [
  {
    path: '/',
    redirect: '/',
    name: 'Página Inicial',
    component: SiteTemplate,
    children: [
      {
        path: '/',
        component: HomeInterna
      },
      {
        path: '/usuarios',
        name: 'Usuários',
        component: Usuario,
        props: (route) => ({ userStatus: route.query.situacao, userType: route.query.tipo })
      },
      {
        path: '/captchas',
        name: 'Captchas',
        component: Captchas
      },
      {
        path: '/noticias',
        name: 'Noticias',
        component: Noticias
      },
      {
        path: '/noticia/cadastrar',
        name: 'Cadastrar Noticias',
        component: NoticiaForm
      },
      {
        path: '/noticia/editar/:id',
        name: 'Editar Noticias',
        component: NoticiaForm
      },
      {
        path: '/noticia/visualizar/:id',
        name: 'Visualizar Noticias',
        component: NoticiaVisualizar
      },
      {
        path: '/conteudos',
        name: 'Conteúdos Informativos',
        component: Conteudos
      },
      {
        path: '/conteudo/cadastrar',
        name: 'Cadastrar Conteúdos',
        component: ConteudoForm
      },
      {
        path: '/conteudo/editar/:id',
        name: 'Editar Conteúdos',
        component: ConteudoForm
      },
      {
        path: '/conteudo/visualizar/:id',
        name: 'Visualizar Conteúdo',
        component: ConteudoVisualizar
      },
      {
        path: '/captcha/cadastrar',
        name: 'Cadastrar Captcha',
        component: CadastrarCaptcha
      },
      {
        path: '/captcha/:id/editar',
        name: 'Editar Captcha',
        component: EditarCaptcha
      },
      {
        path: '/usuario/:id/visualizar',
        name: 'Visualizar Usuário',
        component: UsuarioVisualizar
      },
      {
        path: '/usuario/admin/:id/editar',
        name: 'Edição do Usuário',
        component: UsuarioCadastrar // UsuarioAdminEditar
      },
      {
        path: '/usuario/admin/:id/visualizar',
        name: 'Visualizar Usuário',
        component: UsuarioCadastrar //  UsuarioAdminVisualizar
      },
      {
        path: '/usuario/:id/editar',
        name: 'Editar Usuário',
        component: UsuarioEditar
      },
      {
        path: '/usuario/cadastrar',
        name: 'Cadastrar Usuário',
        component: UsuarioCadastrar
      },
      {
        path: '/usuario/cadastrar-voluntario',
        name: 'Cadastrar do Usuário Voluntário',
        component: CadastroVoluntarioInterno
      },
      {
        path: '/usuario/cadastrar-beneficiaria',
        name: 'Cadastrar do Usuário Beneficiária',
        component: CadastroBeneficiariaInterno
      },
      {
        path: '/usuario/cadastrar-tutor',
        name: 'Cadastrar do Usuário Tutor',
        component: CadastroTutorInstrutorInterno
      },
      {
        path: '/usuario/cadastrar-gestor',
        name: 'Cadastrar do Usuário Gestor',
        component: CadastroGestorInterno
      },
      {
        path: '/relatorios/usuarios-situacao',
        name: 'Relatório - Usuárias por Situação',
        component: RelatorioUsuariosSituacao
      },
      {
        path: '/relatorios/usuarios-tipo',
        name: 'Relatório - Tipo de usuária por UF',
        component: RelatorioUsuariosTipo
      },
      {
        path: '/relatorios/usuarios-vinculo',
        name: 'Relatório - Usuárias por Situação',
        component: RelatorioUsuariosVinculo
      },
      {
        path: '/relatorios/usuarios-idade',
        name: 'Relatório - Usuárias por Situação',
        component: RelatorioUsuariosIdade
      },
      {
        path: '/relatorios/usuarios-total',
        name: 'Relatório - Usuárias por Situação',
        component: RelatorioUsuariosTotal
      },
      {
        path: '/relatorios/dashboard',
        name: 'Dashboard',
        component: RelatorioDashboard
      },
      {
        path: '/perfil',
        name: 'Meu Perfil',
        component: MeuPerfil
      },
      {
        path: '/desistir-do-programa',
        name: 'Desistir do Programa',
        component: Desistir
      },
      {
        path: 'perfis',
        name: 'Perfis',
        component: Permissoes
      },
      {
        path: 'perfil/cadastrar',
        name: 'Cadastrar Perfil',
        component: PermissaoCadastrar
      },
      {
        path: 'perfil/:id/editar',
        name: 'Editar Perfil',
        component: PermissaoEditar
      },
      {
        path: '/usuarios-voluntarios',
        name: 'Usuários Voluntários',
        component: UsuariosVoluntarios,
        props: (route) => ({ userStatus: route.query.situacao, userType: route.query.tipo })
      },
      {
        path: '/beneficiaria/:id/visualizar',
        name: 'Formulário de Avaliação',
        component: VisualizarBeneficiaria
      },
      {
        path: '/formulario/:id/avaliacao-encontro',
        name: 'Visualizar Beneficiária',
        component: FormularioAtendimento
      },
      {
        path: '/validar-usuarios-gestor',
        name: 'Validar Usuário - Gestor',
        component: ValidarUsuariosGestor,
        props: (route) => ({ userStatus: route.query.situacao, userType: route.query.tipo })
      },
      {
        path: '/validar-usuarios-tutor',
        name: 'Validar Usuário - Tutor',
        component: ValidarUsuariosTutor,
        props: (route) => ({ userStatus: route.query.situacao, userType: route.query.tipo })
      },
      {
        path: '/principal-voluntario',
        name: 'Página Principal',
        component: PrincipalVoluntario
      },
      {
        path: '/principal-beneficiario',
        name: 'Pagina Principal',
        component: PrincipalBeneficiaria
      },
      {
        path: '/informar-disponibilidade',
        name: 'Informar Disponibilidade',
        component: InformarDisponibilidade
      },
      {
        path: '/beneficiarias',
        name: 'Minhas Beneficiárias',
        component: MinhasBeneficiarias
      },
      {
        path: '/local/cadastrar',
        name: 'Cadastro Locais',
        component: LocalCadastrar
      },
      {
        path: '/local/:id/editar',
        name: 'Editar Local',
        component: LocalEditar
      },
      {
        path: '/locais',
        name: 'Locais',
        component: Locais
      },
      {
        path: '/minha-agenda',
        name: 'Minha Agenda',
        component: VolunteerCalendar
      },
      {
        path: '/configuracoes',
        name: 'Gerenciar Configurações',
        component: Configuracao
      },
      {
        path: '/cursos',
        name: 'Cursos',
        component: Cursos
      },
      {
        path: '/cursos-listar',
        name: 'Cursos',
        component: CursosLista
      },
      {
        path: '/curso/cadastrar',
        name: 'Cadastrar Curso',
        component: CursoForm
      },
      {
        path: '/curso/editar/:id',
        name: 'Editar Curso',
        component: CursoForm
      },
      {
        path: '/informacoes-noticias',
        name: 'Informações e Notícias',
        component: Informacao
      },
      {
        path: '/informacoes-noticias/:id/visualizar',
        name: 'Informações e Notícias',
        component: InformacaoVisualizar
      },
      {
        path: '/informacoes',
        name: 'Informações',
        component: Informacoes
      },
      {
        path: '/informacao/cadastrar',
        name: 'Cadastrar Informação',
        component: InformacaoForm
      },
      {
        path: '/informacao/editar/:id',
        name: 'Editar Informação',
        component: InformacaoForm
      },
      {
        path: '/programas',
        name: 'Programas',
        component: Programas
      },
      {
        path: '/programa/cadastrar',
        name: 'Cadastrar Progamas',
        component: ProgramaForm
      },
      {
        path: '/programa/editar/:id',
        name: 'Editar Programa',
        component: ProgramaForm
      },
      {
        path: '/programas-listar',
        name: 'Programas',
        component: ProgramaLista
      },
      {
        path: '/admin/programas-municipios',
        name: 'Programas do Município',
        component: ProgramasDeMunicipio
      },
      {
        path: '/programas-municipios-listar',
        name: 'Programas do Município',
        component: ProgramaMunicipioLista
      },
      {
        path: '/admin/programa-municipio/cadastrar',
        name: 'Cadastrar Progamas de Município',
        component: ProgramaMunicipioForm
      },
      {
        path: '/admin/programa-municipio/editar/:id',
        name: 'Editar Programa de Município',
        component: ProgramaMunicipioForm
      },
      {
        path: '/programas-municipios',
        name: 'Programas do Município',
        component: ProgramasDeMunicipioGestor
      },
      {
        path: '/programa-municipio/cadastrar',
        name: 'Cadastrar Progamas de Município',
        component: ProgramaMunicipioFormGestor
      },
      {
        path: '/programa-municipio/editar/:id',
        name: 'Editar Programa de Município',
        component: ProgramaMunicipioFormGestor
      },
      {
        path: '/municipios',
        name: 'Municípios',
        component: Municipios
      },
      {
        path: '/municipio/cadastrar',
        name: 'Cadastrar Município',
        component: MunicipioForm
      },
      {
        path: '/municipio/editar/:id',
        name: 'Editar Município',
        component: MunicipioForm
      },
      {
        path: '/municipios-gestor',
        name: 'Município',
        component: MunicipioFormGestor
      },
      {
        path: '/municipios-tutor',
        name: 'Município',
        component: MunicipioFormGestor
      },
      {
        path: '/relatorio-encontros',
        name: 'Relatórios de Encontros',
        component: RelatorioEncontroBeneficiaria
      },
      {
        path: '/relatorio-encontros/novo',
        name: 'Novo Relatório de Encontro',
        component: RelatorioEncontroBeneficiariaForm
      },
      {
        path: '/relatorio-encontros/editar/:id',
        name: 'Editar Relatório de Encontro',
        component: RelatorioEncontroBeneficiariaForm
      },
      {
        path: '/relatorio-encontros/visualizar/:id',
        name: 'Visualizar Relatório de Encontro',
        component: RelatorioEncontroBeneficiariaVisual
      },
      {
        path: '/avaliar-voluntarias/novo',
        name: 'Avaliar Voluntária',
        component: AvaliarEncontroForm
      },
      {
        path: '/avaliar-voluntarias/editar/:id',
        name: 'Editar Avaliação da Voluntária',
        component: AvaliarEncontroForm
      },
      {
        path: '/avaliar-voluntarias',
        name: 'Listar Avaliação de Voluntárias',
        component: AvaliarEncontro
      },
      {
        path: '/feedbacks/novo',
        name: 'Novo Feedback',
        component: FeedbackForm
      },
      {
        path: '/feedbacks/editar/:id',
        name: 'Editar Feedback',
        component: FeedbackForm
      },
      {
        path: '/feedbacks/responder/:id',
        name: 'Responder Feedback',
        component: FeedbackResposta
      },
      {
        path: '/feedbacks/visualizar/:id',
        name: 'Responder Feedback',
        component: FeedbackVisual
      },
      {
        path: '/feedbacks',
        name: 'Listar Feedbacks',
        component: Feedback
      },
      {
        path: '/depoimentos',
        name: 'Listar Depoimentos',
        component: Depoimentos
      },
      {
        path: '/depoimentos/list',
        name: 'Listar Depoimentos',
        component: ListDepoimentos
      },
      {
        path: '/textos',
        name: 'Textos de Apresentação',
        component: Texto
      },
      {
        path: '/texto/novo',
        name: 'Cadastrar Texto de Apresentação',
        component: TextoForm
      },
      {
        path: '/texto/editar/:id',
        name: 'Editar Texto de Apresentação',
        component: TextoForm
      },
      {
        path: '/texto/visualizar/:id',
        name: 'Visualizar Texto de Apresentação',
        component: TextoForm
      },
      {
        path: '/faqs/list',
        name: 'Listar Faqs',
        component: ListFaq
      },
      {
        path: '/faqs',
        name: 'Gerenciar Faqs',
        component: Faq
      },
      {
        path: '/faqs/novo',
        name: 'Faq Novo',
        component: FaqForm
      },
      {
        path: '/faqs/edit/:id',
        name: 'Faq Editar',
        component: FaqForm
      },
      {
        path: '/faqs/visualizar/:id',
        name: 'Faq Visualizar',
        component: FaqVisual
      },
      {
        path: '/relatorio-mensal',
        name: 'Gerenciar Relatórios Mensais',
        component: RelatorioMensal
      },
      {
        path: '/relatorio-mensal/novo',
        name: 'Relatórios Mensais Novo',
        component: RelatorioMensalForm
      },
      {
        path: '/relatorio-mensal/edit/:id',
        name: 'Faq Editar',
        component: RelatorioMensalForm
      },
      {
        path: '/relatorio-mensal/visualizar/:id',
        name: 'Faq Visualizar',
        component: RelatorioVisual
      },
      {
        path: '/arquivos-menu',
        name: 'Gerenciar Arquivos de Menu',
        component: ArquivosMenu
      },
      {
        path: '/arquivos-regulamento',
        name: 'Download Arquivos de Menu',
        component: () => abrirDocumento(1)
      },
      {
        path: '/arquivos-termo',
        name: 'Download Arquivos de Menu',
        component: () => abrirDocumento(2)
      },
      {
        path: '/arquivos-guia',
        name: 'Download Arquivos de Menu',
        component: () => abrirDocumento(3)
      },
      {
        path: '/arquivos-ebook',
        name: 'Download Arquivos de Menu',
        component: () => abrirDocumento(4)
      },
      {
        path: '/instituicao',
        name: 'Pesquisar Instituição',
        component: Instituicao
      },
      {
        path: '/instituicao/visualizar/:id',
        name: 'Visualizar Instituição',
        component: InstituicaoForm
      },
      {
        path: '/rede',
        name: 'Pesquisar Redes',
        component: Rede
      },
      {
        path: '/rede/visualizar/:id',
        name: 'Visualizar Rede',
        component: RedeForm
      },
      {
        path: '/rede/visualizar/:id/:cat',
        name: 'Visualizar Rede',
        component: RedeForm
      },
      {
        path: '/mensagens',
        name: 'Mensagens',
        component: Mensages
      },
      {
        path: '/mensagem/cadastrar',
        name: 'Cadastrar Mensagem',
        component: MensageForm
      },
      {
        path: '/mensagem/editar/:id',
        name: 'Editar Mensagem',
        component: MensageForm
      },
      {
        path: '/mensagem/visualizar/:id',
        name: 'Visualizar Mensagem',
        component: MensageVisualizar
      },
      {
        path: '/mensagem/reencaminhar/:id',
        name: 'Reencaminhar Mensagem',
        component: MensageReencaminhar
      },
      {
        path: '/classifica',
        name: 'Classificar Rede de Promoção',
        component: ClassificaRede
      },
    ]
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/login-admin',
    component: LoginAdmin
  },
  {
    path: '/cadastro',
    component: Cadastro
  },
  {
    path: '/recuperar-senha',
    component: RecuperarSenha
  },
  {
    path: '/alterar-senha/:token',
    component: AlterarSenha
  },
  {
    path: '/confirmar-cadastro/:token',
    component: GerarSenha
  },
  {
    path: '/primeiro-acesso',
    component: PrimeiroAcesso
  },
  /* {
    path: '/externa',
    name: 'Área Externa',
    component: HomeExterna
  }, */
  {
    path: '/captcha-externa',
    name: 'Captcha Externa',
    component: CaptchaExterno
  },
  {
    path: '/captcha-erro',
    name: 'Captcha Externa Erro',
    component: CaptchaErro
  },
  {
    path: '/cadastro-externo',
    name: 'Cadastro Externo',
    component: CadastroExterno
  },
  {
    path: '/cadastro-beneficiaria',
    name: 'Cadastro Beneficiária',
    component: CadastroBeneficiaria
  },
  {
    path: '/cadastro-gestor',
    name: 'Cadastro Gestor',
    component: CadastroGestor
  },
  {
    path: '/cadastro-tutor',
    name: 'Cadastro Tutor ',
    component: CadastroTutorInstrutor
  },
  {
    path: '/cadastro-voluntario',
    name: 'Cadastro Voluntário',
    component: CadastroVoluntario
  },
  {
    path: '/external-redirect',
    name: 'Redirecionamento Gov',
    component: RedirectGov
  },
  {
    path: '/redirect-login',
    name: 'Redirecionamento Gov',
    component: RedirectGov
  },
  {
    path: '/atualiza-cadastro/:id',
    nome: 'Atualiza Cadastro',
    component: AtualizaPerfil
  },
  {
    path: '/aviso-app',
    nome: 'Aviso Aplicativo',
    component: AvisoAppLogin
  }
]

export default routes

function abrirDocumento (item) {
  let imagemAtual1 = ''
  let imagemAtual2 = ''
  let imagemAtual3 = ''
  let imagemAtual4 = ''
  Vue.http.get('api/arquivosmenu').then((response) => {
    imagemAtual1 = response.body.data.data[0] ? response.body.data.data[0].regulamento_projeto : ''
    imagemAtual2 = response.body.data.data[0] ? response.body.data.data[0].termo_voluntario : ''
    imagemAtual3 = response.body.data.data[0] ? response.body.data.data[0].guia_encontro : ''
    imagemAtual4 = response.body.data.data[0] ? response.body.data.data[0].ebook : ''

    switch (item) {
      case 1: window.open(imagemAtual1, '_blank'); break
      case 2: window.open(imagemAtual2, '_blank'); break
      case 3: window.open(imagemAtual3, '_blank'); break
      case 4: window.open(imagemAtual4, '_blank'); break
    }
  })
}



// WEBPACK FOOTER //
// ./src/router/index.js